import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-24 flex items-center justify-between xs:px-4 lg:px-28 text-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = { class: "absolute" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalSearchBar = _resolveComponent("ModalSearchBar")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Cart = _resolveComponent("Cart")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col fixed z-30 w-screen h-16 bg-black hover:bg-white overscroll-contain",
    onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeColors = true)),
    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeColors = false))
  }, [
    _createVNode(_component_ModalSearchBar, {
      show: _ctx.modals === 'searchBar',
      close: _ctx.closeModals
    }, null, 8, ["show", "close"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        to: "/",
        class: "flex items-center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: "img/logoBranco.svg",
            class: _normalizeClass(["xs:w-20 sm:w-28", _ctx.changeColors ? 'hidden' : 'block'])
          }, null, 2),
          _createElementVNode("img", {
            src: "img/logoPreto.svg",
            class: _normalizeClass(["xs:w-20 sm:w-28", _ctx.changeColors ? 'block' : 'hidden'])
          }, null, 2),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.changeColors ? 'text-black' : 'text-white')
          }, " | Loja ", 2)
        ]),
        _: 1
      }),
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["flex gap-6", _ctx.changeColors ? 'text-black' : 'text-white'])
      }, [
        _createElementVNode("div", {
          class: "p-2 cursor-pointer rounded-full hover:bg-black hover:text-white",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modals = 'searchBar'))
        }, [
          _createVNode(_component_Icon, {
            icon: "mdi:magnify",
            class: "text-xl"
          })
        ]),
        _createElementVNode("div", {
          class: "relative inline-flex items-center cursor-pointer hover:bg-black hover:text-white rounded-full p-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modals = 'cart')),
          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeCounterCart = true)),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeCounterCart = false))
        }, [
          _createVNode(_component_Icon, {
            icon: "mdi:cart",
            class: "text-xl"
          }),
          _createElementVNode("p", {
            class: _normalizeClass([
              _ctx.changeColors && !_ctx.changeCounterCart
                ? 'text-white bg-black border-2 border-black'
                : 'text-black bg-white border-2 border-black'
            , "absolute z-10 font-semibold left-2 inline-block translate-y-1/2 translate-x-2/4 py-0.5 px-1 text-center align-baseline rounded-full leading-none text-xs"])
          }, _toDisplayString(_ctx.quantityCart), 3)
        ], 32)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Cart, {
          show: _ctx.modals === 'cart',
          fechar: _ctx.closeModals
        }, null, 8, ["show", "fechar"])
      ])
    ])
  ], 32))
}